// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import { selectDarkMode } from "../../../../app/store/slices/uiSlice";
// import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
// import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";

// const AccordionSection = ({ title, children, defaultOpen = false }) => {
//   const [isOpen, setIsOpen] = useState(defaultOpen);
//   const darkMode = useSelector(selectDarkMode);

//   return (
//     <div className={`border rounded-lg overflow-hidden ${darkMode ? "border-gray-700" : "border-gray-200"}`}>
//       <button onClick={() => setIsOpen(!isOpen)} className={`w-full px-4 py-3 flex items-center justify-between text-left font-medium transition-colors ${darkMode ? "bg-gray-800 hover:bg-gray-700 text-white" : "bg-gray-50 hover:bg-gray-100 text-gray-900"}`}>
//         <span>{title}</span>
//         {isOpen ? <ChevronUpIcon className="w-5 h-5" /> : <ChevronDownIcon className="w-5 h-5" />}
//       </button>
//       {isOpen && <div className={`px-4 py-4 ${darkMode ? "bg-gray-800/50" : "bg-white"}`}>{children}</div>}
//     </div>
//   );
// };

// const FieldRow = ({ label, value }) => {
//   const darkMode = useSelector(selectDarkMode);
//   return (
//     <div className="flex flex-col sm:flex-row sm:items-center py-2 border-b last:border-b-0 border-gray-100 dark:border-gray-700">
//       <span className={`text-sm font-medium w-full sm:w-1/3 ${darkMode ? "text-gray-400" : "text-gray-500"}`}>{label}</span>
//       <span className={`text-sm w-full sm:w-2/3 ${darkMode ? "text-white" : "text-gray-900"}`}>{value || "—"}</span>
//     </div>
//   );
// };

// const formatDate = (dateString) => {
//   if (!dateString) return "—";
//   return new Date(dateString).toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// };

// const formatCurrency = (value) => {
//   if (!value && value !== 0) return "—";
//   return `₹${parseFloat(value).toLocaleString("en-IN")}`;
// };

// export default function PlanExpandRow({ item }) {
//   const darkMode = useSelector(selectDarkMode);

//   return (
//     <div className="space-y-3">
//       {/* Vaccine Information */}
//       <AccordionSection title="Vaccine Information" defaultOpen={true}>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
//           <FieldRow label="Vaccine Name" value={item.vaccine?.name || item.vaccineName} />
//           <FieldRow label="Batch Number" value={item.batchNumber} />
//           <FieldRow label="Vaccination Center" value={item.vaccinationCenter?.name || item.clinicName} />
//           <FieldRow label="Status" value={<StatusBadge status={item.status || "ACTIVE"} />} />
//         </div>
//       </AccordionSection>

//       {/* Quantity & Doses */}
//       <AccordionSection title="Quantity & Doses">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
//           <FieldRow label="Quantity (Vials)" value={item.quantity ? `${item.quantity} vials` : "—"} />
//           <FieldRow label="Doses Per Vial" value={item.dosesInVial} />
//           <FieldRow label="Total Doses" value={<span className="font-semibold text-blue-600">{item.totalDoses || (item.quantity && item.dosesInVial ? item.quantity * item.dosesInVial : "0")} doses</span>} />
//           <FieldRow label="Remaining Doses" value={item.remainingDoses ? `${item.remainingDoses} doses` : "0"} />
//           <FieldRow label="Remaining Full Vials" value={item.remainingFullVials ? `${item.remainingFullVials} vials` : "—"} />
//           <FieldRow label="Open Vial Doses" value={item.openVialDoses ? `${item.openVialDoses} doses` : "0"} />
//           <FieldRow label="Cost Per Unit" value={formatCurrency(item.costPerUnit)} />
//           <FieldRow label="Completed Vials" value={item.remainingFullVials && item.quantity ? `${item.quantity - item.remainingFullVials} vials` : "—"} />
//         </div>
//       </AccordionSection>

//       {/* Storage & Dates */}
//       <AccordionSection title="Storage & Dates">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
//           <FieldRow label="Manufacturer" value={item.manufacturer?.supplierName || item.supplier?.name} />
//           <FieldRow label="Storage Location" value={item.storageLocation} />
//           <FieldRow label="Storage Temperature" value={item.temperature} />
//           <FieldRow label="Manufacturing Date" value={formatDate(item.manufacturingDate)} />
//           <FieldRow label="Expiry Date" value={formatDate(item.expiryDate)} />
//           <FieldRow label="Received Date" value={formatDate(item.receivedDate)} />
//         </div>
//       </AccordionSection>

//       {/* Notes */}
//       {item.notes && (
//         <AccordionSection title="Notes">
//           <p className={`text-sm ${darkMode ? "text-gray-300" : "text-gray-600"}`}>{item.notes}</p>
//         </AccordionSection>
//       )}
//     </div>
//   );
// }
import React from "react";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";

const PlanExpandRow = ({ item }) => {
  const sections = [
    {
      id: "schedule",
      title: "basic info",
      fields: [
        { label: "Vaccine Name", value: item.vaccine?.name || item.vaccineName || "—" },
        { label: "Age Group", value: item.ageGroupLabel || "—" },
        { label: "Number Of Doses ", value: item.doseNumber ?? "—" },
        { label: "Display Order", value: item.displayOrder ?? "—" },
        { label: "Required", value: item.isRequired ? "Yes" : "No" },
        { label: "Age (Days)", value: item.ageInDays ?? "—" },
        { label: "Age (Months)", value: item.ageInMonths ?? "—" },
        {
          label: "Description",
          value: item.description || "—",
          isLong: true,
        },
      ],
    },
    // {
    //   id: "age",
    //   title: "Age Details",
    //   fields: [

    //   ],
    // },
    // {
    //   id: "status",
    //   title: "Status",
    //   fields: [
    //     {
    //       label: "Status",
    //       value: <StatusBadge status={item.status || "ACTIVE"} />,
    //     },
    //   ],
    // },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default PlanExpandRow;
